import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { UpcomingRemindersService } from '../../services/upcoming-reminders/upcoming-reminders.service';
import { Store, select } from '@ngrx/store';
import { selectUpcomingReminders } from 'app/dashboard/features/dashboard.selectors';
import { loadUpcomingReminders } from 'app/dashboard/features/dashboard.actions';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-upcoming-reminders',
  templateUrl: './upcoming-reminders.component.html',
  styleUrls: ['./upcoming-reminders.component.scss']
})
export class UpcomingRemindersComponent implements OnInit {
  destroyRef = inject(DestroyRef)
  upcomingReminders$ = this.store.pipe(
    select(selectUpcomingReminders)
  );

  public reminders = null;

  public isUpcomingRemindersExist = true

  constructor(
    public upcomingRemindersService: UpcomingRemindersService,
    public store: Store,
  ) { }

  ngOnInit(): void {
    this.isUpcomingRemindersExist = false;

    this.store.dispatch({
      type: loadUpcomingReminders.type,
      payload: { }
    });

    this.upcomingReminders$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((upcomingReminders)=>{

      if(upcomingReminders.length > 0) {
        this.isUpcomingRemindersExist = true;
        this.reminders = upcomingReminders;
      }
      else 
        this.isUpcomingRemindersExist = false;
    });
  }

  ngOnDestroy() {
  }
}
